define( function() {
	"use strict";

	return [];
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201703161753-430ad182f9-master/~/jquery/src/var/arr.js
// module id = 109
// module chunks = 1